import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import {
  change as changeFieldValue, Field, formValueSelector, reduxForm
} from 'redux-form';
import {
  maxValueMonetario,
  renderFieldMonetarioLabelEncima, renderFieldNumeros, renderFieldPercentual, renderFieldSelect, renderFieldText, required, requiredSelect
} from '../../util/inputs';
import { realParaNumber } from '../../util/numberUtil';
import FormCadastroNotaFiscal from './FormCadastroNotaFiscal';
import adicionarDadosPagamentoEncomenda from '../../actions/encomenda/adicionarDadosPagamentoEncomenda';
import FormCadastrarFormaPagamentoEncomenda from './FormCadastrarFormaPagamentoEncomenda';
import { tamanhoArquivoUpload, LIMITE_UPLOAD_ARQUIVO_ENCOMENDA } from '../../util/applicationContext';
import { gerarHashForString } from '../../util/stringUtil';
import FormasPagamento from './FormasPagamento';
import NotasFiscais from './NotasFiscais';
import { showAlertMsg } from '../../util/messagesUtil';
import adicionaEhRemoveImagensEncomenda from '../../actions/encomenda/adicionaEhRemoveImagensEncomenda';
import ImageGridUpload from './ImageGridUpload';
import Modal from './Modal';

const selector = formValueSelector('formularioCadastroEncomenda');
export const VALORCOMBINADO = 'VALOR_COMBINADO';
export const VALORPORKG = 'VALOR_POR_KG';
export const PRECOFIXOMAISVALORPORKG = 'PRECO_FIXO_MAIS_VALOR_POR_KG';

export class AbaPagamento extends React.Component {
  constructor(props) {
    super(props);
    this.alterarTipoCalculo = this.alterarTipoCalculo.bind(this);

    this.state = {
      habilitadoValorDeclarado: false,
      habilitaValorNotaFiscal: false,
      arquivos: [],
      selectedImg: null
    }
  }

  componentDidMount() {
    if (this.props.dadosPagamentoEncomenda.habilitadoSeguro) {
      if (this.props.dadosPagamentoEncomenda.habilitadoValorDeclarado) {
        this.setState({ habilitadoValorDeclarado: this.props.dadosPagamentoEncomenda.habilitadoValorDeclarado, habilitaValorNotaFiscal: false });
        this.props.changeFieldValue('formularioCadastroEncomenda', 'valorProduto', this.props.dadosPagamentoEncomenda.valorProduto.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }));
      }
      if (this.props.dadosPagamentoEncomenda.habilitaValorNotaFiscal) {
        this.setState({ habilitadoValorDeclarado: false, habilitaValorNotaFiscal: this.props.dadosPagamentoEncomenda.habilitaValorNotaFiscal });
        this.limparCampoValorProduto();
      }
    } else {
      this.setState({ habilitadoValorDeclarado: false, habilitaValorNotaFiscal: false });
      this.limparCampoValorProduto();
    }
    this.carregarFormulario();
  }

  alterarValorCalculado = (event) => {
    let quantidadeKg = 0;
    const precoFixo = realParaNumber(this.props.precoFixo);
    const valorInformado = Number(event.target.value);

    let valorCalculado = 0;
    if (this.props.tipoCalculo.value === VALORPORKG) {
      quantidadeKg = realParaNumber(this.props.precoKg);
      valorCalculado = quantidadeKg * valorInformado;
    }

    if (this.props.tipoCalculo.value === PRECOFIXOMAISVALORPORKG) {
      quantidadeKg = realParaNumber(this.props.valorKg);
      valorCalculado = precoFixo + quantidadeKg * valorInformado;
    }

    const valorCalculadoFormatado = valorCalculado.toString()
      .replace('.', ',');
    this.props.adicionarDadosPagamentoEncomenda({ ...this.props.dadosPagamentoEncomenda, valorCalculado: valorCalculadoFormatado, quantidadeKg: valorInformado });
    this.props.changeFieldValue('formularioCadastroEncomenda',
      'valorCalculado', valorCalculadoFormatado);
  };

  exibirCamposValor() {
    if (this.props.tipoCalculo) {
      if (this.props.tipoCalculo.value === VALORCOMBINADO) {
        return (
          <div className="col-12 col-sm-12 col-md-2">
            <Field name='valorCombinado' validate={[required]}
              component={renderFieldMonetarioLabelEncima}
              className="form-control" label="Valor"
              handleChange={e => this.props.adicionarDadosPagamentoEncomenda({ ...this.props.dadosPagamentoEncomenda, valorCombinado: e.target.value })} />
          </div>
        )
      }
      if (this.props.tipoCalculo.value === VALORPORKG
        || this.props.tipoCalculo.value === PRECOFIXOMAISVALORPORKG) {
        return (
          <React.Fragment>
            {this.props.tipoCalculo.value === PRECOFIXOMAISVALORPORKG && <><div className="col-12 col-md-2">
              <Field name='precoFixo' validate={[required]} component={renderFieldMonetarioLabelEncima} className="form-control" label="Preço Fixo" readOnly />
            </div><div className="mt-5">
                <span>+</span>
              </div></>}

            {this.props.tipoCalculo.value === PRECOFIXOMAISVALORPORKG && <div className="col-12 col-md-2">
              <Field name='valorKg' validate={[required]} component={renderFieldMonetarioLabelEncima} className="form-control" label="Valor por KG" readOnly
              />
            </div>}

            {this.props.tipoCalculo.value === VALORPORKG && <div className="col-12 col-md-2">
              <Field name='precoKg' validate={[required]} component={renderFieldMonetarioLabelEncima} className="form-control" label="Valor por KG" readOnly
              />
            </div>}

            <div className="mt-5">
              <span>X</span>
            </div>
            <div className="col-12 col-md-2">
              <Field name='quantidadeKg' validate={[required]} component={renderFieldPercentual} className="form-control" label="Peso" handleChange={this.alterarValorCalculado.bind(this)} />
            </div>
            <div className="mt-5">
              <span>=</span>
            </div>
            <div className="col-12 col-md-2">
              <Field name='valorCalculado' validate={[required]} component={renderFieldMonetarioLabelEncima} className="form-control" label="Valor" readOnly />
            </div>
          </React.Fragment>
        )
      }
    }
  }

  exibirFormasPagamento() {
    if (this.props.dadosPagamentoEncomenda.formasPagamento.length) {
      return (<FormasPagamento exibeRemover
        verificarSeFormaPagamentoNaoFoiSelecionado={this.props.verificarSeFormaPagamentoNaoFoiSelecionado} />)
    }
  }

  limparFormularioNotaFiscal() {
    this.props.reset('formularioCadastroNotaFiscal');
    this.props.changeFieldValue('formularioCadastroNotaFiscal',
      'valor', '0');
    this.props.changeFieldValue('formularioCadastroNotaFiscal',
      'peso', '0');
    this.props.changeFieldValue('formularioCadastroNotaFiscal',
      'volume', '0');
    this.props.changeFieldValue('formularioCadastroNotaFiscal',
      'numeroDocumento', '');
  }

  alterarTipoCalculo(e) {
    this.props.adicionarDadosPagamentoEncomenda({
      ...this.props.dadosPagamentoEncomenda, tipoCalculo: e, valorCalculado: '0', quantidadeKg: '0', valorCombinado: '0'
    });
  }

  handleCheckedValorDeclarao() {
    if (!this.props.configuracaoEncomenda.habilitadoTaxaSeguro) {
      showAlertMsg('A taxa de seguro não foi configurado!')
      return;
    }

    let taxaSeguro = 0;
    if (this.props.configuracaoEncomenda.habilitadoTaxaSeguro) {
      taxaSeguro = realParaNumber(this.props.configuracaoEncomenda.taxaSeguro) / 100;
    }

    if (this.state.habilitadoValorDeclarado) {
      this.props.adicionarDadosPagamentoEncomenda({
        ...this.props.dadosPagamentoEncomenda,
        habilitadoValorDeclarado: false,
        valorProduto: 0,
        habilitadoSeguro: this.state.habilitaValorNotaFiscal,
      });
      this.setState({
        habilitadoValorDeclarado: !this.state.habilitadoValorDeclarado
      });

      this.limparCampoValorProduto();
      this.limparCamposValoresDinheiroCartao();

    } else {
      this.props.adicionarDadosPagamentoEncomenda({
        ...this.props.dadosPagamentoEncomenda,
        habilitadoValorDeclarado: true,
        valorProduto: this.props.valorProduto ? this.props.valorProduto : 0,
        habilitaValorNotaFiscal: false,
        habilitadoSeguro: true,
        taxaSeguro: taxaSeguro,
        valorSeguro: this.props.valorProduto ? realParaNumber(this.props.valorProduto) * taxaSeguro : 0
      });

      this.setState({
        habilitadoValorDeclarado: !this.state.habilitadoValorDeclarado,
        habilitaValorNotaFiscal: false
      });

    }

  }

  handleCheckedValorNotaFiscal() {
    if (!this.props.configuracaoEncomenda.habilitadoTaxaSeguro) {
      showAlertMsg('A taxa de seguro não foi configurado!');
      return;
    }

    let taxaSeguro = 0;
    if (this.props.configuracaoEncomenda.habilitadoTaxaSeguro) {
      taxaSeguro = realParaNumber(this.props.configuracaoEncomenda.taxaSeguro) / 100;
    }
    if (this.state.habilitaValorNotaFiscal) {
      this.props.adicionarDadosPagamentoEncomenda({
        ...this.props.dadosPagamentoEncomenda,
        habilitaValorNotaFiscal: false,
        habilitadoSeguro: this.state.habilitadoValorDeclarado,
        valorProduto: this.props.valorProduto ? this.props.valorProduto : 0,
      });
      this.setState({
        habilitaValorNotaFiscal: !this.state.habilitaValorNotaFiscal
      });

      this.limparCamposValoresDinheiroCartao();

    } else {
      this.props.adicionarDadosPagamentoEncomenda({
        ...this.props.dadosPagamentoEncomenda,
        habilitadoValorDeclarado: false,
        valorProduto: 0,
        habilitaValorNotaFiscal: true,
        taxaSeguro: taxaSeguro,
        habilitadoSeguro: true
      });
      this.setState({
        habilitadoValorDeclarado: false,
        habilitaValorNotaFiscal: !this.state.habilitaValorNotaFiscal
      });

      this.limparCampoValorProduto();
    }
  }

  exibeCamposSeguro() {
    return (
      <div className='mt-4'>
        <div className="form-row">
          <label>Cobrar Seguro Por: </label>
        </div>
        <div className='col-12 col-sm-8 col-md-8'>
          <div className="form-row" style={{ alignItems: 'flex-end' }}>
            <div className='form-group form-check col-12 col-sm-3 col-md-3'>
              <input type="checkbox" name='habilitadoValorDeclarado'
                className='form-check-input' onChange={this.handleCheckedValorDeclarao.bind(this)} value={this.state.habilitadoValorDeclarado} checked={this.state.habilitadoValorDeclarado} />
              <label className='form-check-label'>Valor declarado:</label>
            </div>
            {this.state.habilitadoValorDeclarado && (
              <div className='col-12 col-sm-3 col-md-3'>
                <Field
                  name="valorProduto"
                  validate={[maxValueMonetario, required]}
                  component={renderFieldMonetarioLabelEncima}
                  label="Valor do produto:"
                  handleChange={(e) => this.adicionarValorProduto(e)}
                />
              </div>)}
          </div>
        </div>
        <div className='col-12 col-sm-8 col-md-8'>
          <div className="form-row mb-2">
            <div className='form-group form-check col-12 col-sm-3 col-md-3'>
              <input type="checkbox" name='habilitaValorNotaFiscal'
                className='form-check-input' onChange={this.handleCheckedValorNotaFiscal.bind(this)} value={this.state.habilitaValorNotaFiscal} checked={this.state.habilitaValorNotaFiscal} />
              <label className='form-check-label'>Valor nota fiscal:</label>
            </div>
          </div>
        </div>

      </div>
    )
  }

  carregarFormulario() {

    this.props.changeFieldValue('formularioCadastroEncomenda', 'base64ImagemEncomenda', null);
    this.props.changeFieldValue('formularioCadastroEncomenda', 'nomeImagemEncomenda', null);
    this.props.changeFieldValue('formularioCadastroEncomenda', 'urlImagem', null);

    if (this.props.base64ImagemEncomenda || this.props.urlImagem) {
      const imagens = this.props.configuracaoEncomenda.imagens.map(it => {
        return {
          hash: gerarHashForString(`${it.nome}`),
          ...it
        }
      });
      this.setState({ arquivos: imagens });
    }

  }

  handleChange(event) {
    const chooseFiles = Array.prototype.slice.call(event.target.files);
    const arquivos = [...this.state.arquivos];

    const mensagens = [];

    const mensagem = {
      tipo: 'erro',
      nomeArquivo: '',
      texto: 'Limite excedido de arquivos para upload.'
    };

    if (chooseFiles.length > LIMITE_UPLOAD_ARQUIVO_ENCOMENDA) {
      mensagem.nomeArquivo = chooseFiles[chooseFiles.length - 1].name;
      mensagens.push(mensagem);
      this.setState({ mensagens });
      return;
    }

    const limite = arquivos.length + chooseFiles.length;

    chooseFiles.forEach(file => {
      if (arquivos.findIndex(arq => arq.nome === file.name) === -1) {
        if (/\.(jpe?g|png|webp)$/i.test(file.name) === false) {
          const mensagem = {
            tipo: 'erro',
            nomeArquivo: file.name,
            texto: 'Formato de imagem inválido. Informe uma imagem nos formatos JPEG, PNG ou JPG.'
          };
          mensagens.push(mensagem);
        } else if (limite >= 0 && arquivos.length > LIMITE_UPLOAD_ARQUIVO_ENCOMENDA) {
          const mensagem = {
            tipo: 'erro',
            nomeArquivo: file.name,
            texto: 'Limite excedido de arquivos para upload.'
          };
          mensagens.push(mensagem);
          return;
        } else if (file.size > tamanhoArquivoUpload) {
          const mensagem = {
            tipo: 'erro',
            nomeArquivo: file.name,
            texto: 'Tamanho do arquivo excede 20 MB.'
          };
          mensagens.push(mensagem);
        } else {
          this.converterParaBase64(file);
        }
      }
    })

    this.setState({ mensagens });
  }

  converterParaBase64(file) {
    const obj = {
      hash: gerarHashForString(`${file.name}`),
      nome: file.name,
      base64ImagemEncomenda: null,
      urlImagem: null,
    };

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      const arquivos = [...this.state.arquivos];
      obj.base64ImagemEncomenda = reader.result;
      obj.urlImagem = reader.result;
      arquivos.push(obj);

      this.setState({ arquivos });
      this.props.adicionaEhRemoveImagensEncomenda(arquivos);
    }.bind(this);
    reader.onerror = function () {
      const mensagem = {
        tipo: 'erro',
        nomeArquivo: file.name,
        texto: 'Imagem inválida. Selecione outra imagem.'
      };
      const mensagens = [...this.state.mensagens];
      mensagens.push(mensagem);
      this.setState({ mensagens });
      this.removerImagem(obj);
    }.bind(this);
  }

  exibirImagem() {
    return (
      <>
        {this.state.arquivos.map((arq, index) => (
          <Fragment key={`file-${index}`}>
            <ImageGridUpload key={`file-${index}`} setSelectedImg={this.setSelectedImg.bind(this)} file={arq} removerImagem={this.removerImagem.bind(this)}/>
          </Fragment>
        ))}

        {this.state.selectedImg && <Modal selectedImg={this.state.selectedImg} setSelectedImg={this.setSelectedImg.bind(this)} />}
      </>
    )

  }

  removerImagem(arquivo) {
    const arquivos = [...this.state.arquivos];
    const array = arquivos.filter(it => it.hash != arquivo.hash);

    this.setState({ arquivos: array });
    this.props.adicionaEhRemoveImagensEncomenda(array);
  }

  setSelectedImg(selectedImg) {
    this.setState({ selectedImg })
  }

  limparMensagem() {
    this.setState({ mensagens: [] });
  }

  adicionarValorProduto(e) {
    let valorProduto = 0;
    if (e.target.value) {
      valorProduto = realParaNumber(e.target.value.replace('R$', ''));
    }

    let valorSeguro = 0;
    let taxaSeguro = 0;
    if (this.props.configuracaoEncomenda.habilitadoTaxaSeguro) {
      taxaSeguro = realParaNumber(this.props.configuracaoEncomenda.taxaSeguro) / 100;
      valorSeguro = valorProduto * taxaSeguro;
    }

    this.props.adicionarDadosPagamentoEncomenda({ ...this.props.dadosPagamentoEncomenda, valorProduto, valorSeguro });
  }

  limparCampoValorProduto() {
    this.props.changeFieldValue('formularioCadastroEncomenda', 'valorProduto', '0');
  }

  limparCamposValoresDinheiroCartao() {
    this.props.changeFieldValue('formularioCadastroEncomenda', 'valorDinheiro', '0');
    this.props.changeFieldValue('formularioCadastroEncomenda', 'valorCartao', '0');
  }

  render() {
    return (
      <React.Fragment>
        <div className="form-row mb-2">
          <div className="col-12 col-md-2">
            <Field name="tipoProduto" type="text" validate={[required]} required={true} component={renderFieldText} label="Descrição do produto:"
              css="form-control" readOnly={false} onChange={e => this.props.adicionarDadosPagamentoEncomenda({ ...this.props.dadosPagamentoEncomenda, tipoProduto: e.target.value })} />
          </div>
          <div className="col-12 col-md-2">
            <Field name='tipoCalculo'
              options={this.props.tiposCalculoEncomenda.map(it => ({
                nome: it.chave,
                descricao: it.valor
              }))}
              component={renderFieldSelect}
              label='Tipo de cálculo'
              placeholder='Selecione...'
              validate={requiredSelect}
              onChange={this.alterarTipoCalculo}
            />
          </div>
          <div className="col-12 col-md-1">
            <Field name='volumeEncomendas' css="form-control" validate={[required]} component={renderFieldNumeros} label="Volume"
              onChange={e => this.props.adicionarDadosPagamentoEncomenda({ ...this.props.dadosPagamentoEncomenda, volume: e.target.value })} />
          </div>
          {this.props.tipoCalculo && (this.props.tipoCalculo.value === VALORPORKG || this.props.tipoCalculo.value == VALORCOMBINADO) && this.exibirCamposValor()}
        </div>
        {this.props.tipoCalculo && this.props.tipoCalculo.value === PRECOFIXOMAISVALORPORKG && <div className="form-row">
          {this.exibirCamposValor()}
        </div>}
        <div className='input-wrapper mt-3'>
          <label htmlFor='input-file'>
            {this.props.logoMarca ? 'Alterar imagens encomenda' : 'Adicionar imagens encomenda'}
          </label>
          <input id='input-file' type='file' value='' accept="image/*" onChange={this.handleChange.bind(this)} multiple />
          <span id='file-name' />
        </div>
        <div className='img-grid mt-4'>
          {this.exibirImagem()}
        </div>
        {this.exibeCamposSeguro()}
        <div>
          <div className="col-12 titulo-principal">
            <FormCadastroNotaFiscal />
          </div>

          <div className='col-12'>
            <NotasFiscais notasFiscais={this.props.dadosPagamentoEncomenda.notasFiscais} exibeRemover />
          </div>
        </div>
        <div className='col-12'>
          <fieldset className="scheduler-border">
            <legend className="scheduler-border">Resumo da Encomenda</legend>
            <div className='col-12 col-sm-8 col-md-8'>
              <div className='row'><strong>Valor: </strong><span className='ml-2'>{this.props.recuperarValorTotal().toLocaleString('pt-br', {
                style: 'currency',
                currency: 'BRL'
              })}</span></div>
              {this.props.dadosPagamentoEncomenda.habilitadoSeguro && <><div className='row'><strong>Valor Seguro: </strong><span className='ml-2'>{this.props.calcularValorSeguro().toLocaleString('pt-br', {
                style: 'currency',
                currency: 'BRL'
              })}</span></div><div className='row'><strong>Valor Total: </strong><span className='ml-2'>{this.props.recuperarValorTotalGeral().toLocaleString('pt-br', {
                style: 'currency',
                currency: 'BRL'
              })}</span></div></>}
            </div>
          </fieldset>
        </div>
        <div className='col-12'>
          <div>
          <fieldset className="scheduler-border" style={{ alignContent: 'center', justifyContent: 'center' }}>
            <legend className="scheduler-border">Forma de Pagamento</legend>
            {this.props.dadosPagamentoEncomenda.tipoCalculo ?
              <FormCadastrarFormaPagamentoEncomenda
                verificarSeFormaPagamentoNaoFoiSelecionado={this.props.verificarSeFormaPagamentoNaoFoiSelecionado} />
              : ''}
            <div className='col-12'>
              {this.exibirFormasPagamento()}
            </div>
          </fieldset>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

export const mapStateToProps = state => {
  return {
    empresaSelecionada: state.empresaSelecionada,
    notasFiscais: state.notasFiscais,
    tipoCalculo: selector(state, 'tipoCalculo'),
    volumeEncomendas: selector(state, 'volumeEncomendas'),
    quantidadeKg: selector(state, 'quantidadeKg'),
    dadosPagamentoEncomenda: state.dadosPagamentoEncomenda,
    habilitadoPrecoKg: state.configuracaoEncomenda.habilitadoPrecoKg,
    precoKg: state.configuracaoEncomenda.precoKg,
    habilitadoPrecoFixoMaisValorKg: state.configuracaoEncomenda.habilitadoPrecoFixoMaisValorKg,
    valorKg: state.configuracaoEncomenda.valorKg,
    precoFixo: state.configuracaoEncomenda.precoFixo,
    tiposCalculoEncomenda: state.configuracaoEncomenda.tiposCalculoEncomenda,
    valorProduto: selector(state, 'valorProduto'),
    configuracaoEncomenda: state.configuracaoEncomenda,
    base64ImagemEncomenda: selector(state, 'base64ImagemEncomenda'),
    nomeImagemEncomenda: selector(state, 'nomeImagemEncomenda'),
    urlImagem: selector(state, 'urlImagem'),
    initialValues: {
      habilitadoPrecoKg: state.configuracaoEncomenda.habilitadoPrecoKg,
      precoKg: state.configuracaoEncomenda.precoKg,
      habilitadoPrecoFixoMaisValorKg: state.configuracaoEncomenda.habilitadoPrecoFixoMaisValorKg,
      valorKg: state.configuracaoEncomenda.valorKg,
      precoFixo: state.configuracaoEncomenda.precoFixo,
      tipoProduto: state.dadosPagamentoEncomenda.tipoProduto,
      tipoCalculo: state.dadosPagamentoEncomenda.tipoCalculo,
      volumeEncomendas: state.dadosPagamentoEncomenda.volumeEncomendas,
      quantidadeKg: state.dadosPagamentoEncomenda.quantidadeKg,
      valorCalculado: state.dadosPagamentoEncomenda.valorCalculado,
      valorCombinado: state.dadosPagamentoEncomenda.valorCombinado,

    }
  }
};


export default connect(mapStateToProps, { changeFieldValue, adicionaEhRemoveImagensEncomenda, adicionarDadosPagamentoEncomenda })(reduxForm({
  form: 'formularioCadastroEncomenda',
  enableReinitialize: true,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(AbaPagamento))
